import zappy from '@zappy-ride/library.react.components';
import { RenderByRoute } from './RenderByRoute';

export * from './RenderByRoute';

zappy.FactoryInstance.registerComponent(RenderByRoute);
